import { put, takeLeading } from 'redux-saga/effects'

import { readFFOverrides } from '@webapp/core/services/FeatureFlag'
import { updateFlags, UPDATE_FEATURE_FLAGS } from '@webapp/core/stores/global'
import { updateHasFFOverride, updateLiveFFState } from './actions'

export function* overrideFeatureFlags(action) {
  const localFF = readFFOverrides()

  // Merged flags must be the FIRST put: the triggering UPDATE_FEATURE_FLAGS
  // reducer has already set hasFeatureFlagsResolved, and outside React event
  // handlers each nested dispatch notifies subscribers synchronously — any put
  // before the merge lets flag-gated routes render (and redirect) against the
  // unmerged live flags.
  yield put(
    updateFlags({
      ...action.flags,
      ...localFF,
    })
  )
  yield put(updateLiveFFState(action.flags))

  if (Object.keys(localFF).length > 0) {
    yield put(updateHasFFOverride(true))
  }
}

export default function* watchUpdateFeatureFlags() {
  yield takeLeading(UPDATE_FEATURE_FLAGS, overrideFeatureFlags)
}
